import React, { useEffect, useState, useRef } from 'react'
import './TemplateLogs.css'
import searchbtn from '../../../Assets/images/search.svg'
import Pagination from '../../Pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import { hideLoader, showLoader } from '../../../Redux/Slice/Loader/loaderSlice';
import { useDispatch } from 'react-redux';
import showToast from '../../../Utils/Toast/ToastNotification';
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';
import TemplateService from '../../../Services/TemplateService/TemplateService';
import { useSelector } from 'react-redux';


const TemplateLogs = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [selectedId, setSelectedId] = useState(null)
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [sortBy, setSortBy] = useState("created_at");
    const [sortOrder, setSortOrder] = useState("ASC");
    const [searchQuery, setSearchQuery] = useState("");
    const [templateLogs, setTemplateLogs] = useState([])
    const [isFilterCleared, setIsFilterCleared] = useState(false);
    const [filters, setFilters] = useState({
        page: 1,
        limit: 10,
    });

    const token = useSelector(
        (state) => state.auth?.user?.data?.body?.data?.token
    );

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(e.target.value);
        setPage(0);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setPage(0);
    };

    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
        } else {
            setSortBy(column);
            setSortOrder("ASC");
        }
    };


    const getTemplateLogsList = async () => {
        dispatch(showLoader());
        const params = {
            // search: searchQuery || "",
            page: page + 1,
            limit: rowsPerPage,
        }
        try {
            const response = await TemplateService.getTemplateLogs(params, token)

            if (response?.data?.statusCode == 200) {
                const templateLogsList = response?.data?.body?.data?.logs || [];
                const totalItems = response?.data?.body?.data?.pagination?.total || 0;

                if (templateLogsList.length === 0 && page > 0) {
                    setPage(prev => prev - 1);
                } else {
                    setTemplateLogs(templateLogsList)
                    setTotalRecords(totalItems)
                }
            } else {
                showToast("error", response.data.body?.message);
            }
        }
        catch (error) {
            await HandleApiError(error);
        } finally {
            dispatch(hideLoader());
        }
    }

    useEffect(() => {
        getTemplateLogsList();
    }, [debouncedSearch, page, rowsPerPage, sortBy, sortOrder])

    useEffect(() => {
        if (isFilterCleared) {
            getTemplateLogsList();
            setIsFilterCleared(false);
        }
    }, [isFilterCleared]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchQuery]);


    return (

        <>
            <div className='main-inner-block'>
                <div className='content'>
                    <div className='d-flex align-items-center justify-content-between mb-4 block-one gap-3'>
                        <div className='heading-content ms-0 mt-0'>
                            Template Logs
                        </div>
                        {/* <div className='heading-content mt-0'>
                            <button
                                className="green-btn green-signin addnewuser"
                                onClick={() => navigate("/add-template")}
                            >
                                + Add Template
                            </button>
                        </div> */}
                    </div>
                    <div className='white-box bg-box-mob'>
                        <div className='inner-content-block'>
                            <div className='listing-title-block d-flex justify-content-between'>
                                <div className='box-listing-title'>
                                    Template Logs Details
                                    <span className='d-block'>
                                        Showing a list of Template Logs.
                                    </span>
                                </div>
                                <div className='searchbar-btn d-flex align-items-center gap-4'>
                                    {/* <div className='input-search-box position-relative'>
                                        <input
                                            type="text"
                                            id="name"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={handleSearch}
                                        />
                                        <div className='searchbtn'>
                                            <img src={searchbtn} alt="searchbtn"></img>
                                        </div>
                                        {searchQuery && (
                                            <button
                                                className="clear-btn"
                                                onClick={() => setSearchQuery("")}
                                            >
                                                ✖
                                            </button>
                                        )}
                                    </div> */}
                                    <div className='filter d-flex align-items-center gap-4'>
                                        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div className='text-end'>
                                                        <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>
                                                    </div>

                                                    <div>
                                                        <h1 class="modal-title fs-5 text-center filter-title" id="exampleModalLabel">Data Library Filter</h1>
                                                    </div>
                                                    <div class="modal-body">
                                                        <form onSubmit={(e) => {
                                                            e.preventDefault();
                                                            getTemplateLogsList();
                                                        }}>
                                                            <div class="mb-3">
                                                                <label htmlFor="joinedDate" className="form-label">Joined Date</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    id="joinedDate"

                                                                />

                                                            </div>
                                                            <div class="mb-3">
                                                                <label htmlFor="joinedDate" className="form-label">Joined Date</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    id="joinedDate"

                                                                />

                                                            </div>
                                                            <div className='text-center'>
                                                                <button
                                                                    type="submit"
                                                                    class="green-btn updt-button"
                                                                    data-bs-dismiss="modal"
                                                                // onClick={(e) => handleFilterSubmit(e)}
                                                                >
                                                                    Filter
                                                                </button>
                                                                <button
                                                                    type="submit"
                                                                    class="green-btn updt-button ms-2"
                                                                    data-bs-dismiss="modal"
                                                                // onClick={handleClearFilter}
                                                                >
                                                                    Clear Filter
                                                                </button>
                                                            </div>

                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='table-block'>
                                <table class="table">
                                    <thead class="table-headers">
                                        <tr>
                                            <th>Action</th>
                                            <th>Performed By</th>
                                            <th>Date Created</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {templateLogs.length > 0 ? (
                                            templateLogs.map((log, index) => (
                                                <tr key={log.id}>
                                                    <td>
                                                        {log.action}
                                                    </td>
                                                    <td>
                                                        {`${log.first_name} ${log.last_name}`}
                                                    </td>
                                                    <td style={{ textAlign: log.createdAt ? 'left' : 'center' }}>
                                                        {log.createdAt ?
                                                            new Date(log.createdAt).toLocaleDateString()
                                                            : "-"
                                                        }
                                                    </td>
                                                    <td>
                                                        <div className="d-flex gap-3">
                                                            <a
                                                                className="tooltip-container flex align-items-center text-decoration-none fonticon"
                                                                onClick={() => navigate(`/view-template-logs/${log.id}`)}
                                                            >
                                                                <i className="fas fa-eye me-2"></i>
                                                                <span className="tooltip-text">View Logs</span>
                                                            </a>

                                                        </div>
                                                    </td>
                                                </tr>))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    No Templates Logs Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {/* responsive */}
                            <div className="mobile-user-list d-block d-md-none">
                                {templateLogs.length > 0 ? (
                                    templateLogs.map((templateLogs, index) => (
                                        <div key={templateLogs.id} className="col-md-6 col-lg-4 mb-4">
                                            <div className="card shadow-sm h-100">
                                                <div className="card-body">

                                                    <p className="mb-1">
                                                        <strong>Action:</strong>{" "}
                                                        {templateLogs.action}
                                                    </p>

                                                    <p className="mb-1">
                                                        <strong>Performed By:</strong>{" "}
                                                        {templateLogs.first_name} {templateLogs.last_name}
                                                    </p>

                                                    <p className="mb-1">
                                                        <strong>Date Created:</strong>{" "}
                                                        {templateLogs.createdAt
                                                            ? new Date(templateLogs.createdAt).toLocaleDateString()
                                                            : "-"}
                                                    </p>


                                                    <div className="d-flex justify-content-end mt-3 gap-3">
                                                        <a
                                                            className="flex align-items-center text-decoration-none fonticon"
                                                            onClick={() => navigate(`/view-template-logs/${templateLogs.id}`)}
                                                        >
                                                            <i className="fas fa-eye me-2"></i>

                                                        </a>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center">
                                        <div className="alert alert-info">No Template logs found</div>
                                    </div>
                                )}
                            </div>


                            <div className="pagination-block">
                                {/* {
                                    <Pagination
                                        count={totalRecords}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onRowsPerPageChange={handleRowsPerPageChange}
                                    />
                                } */}
                                {
                                    <Pagination
                                        count={totalRecords}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onRowsPerPageChange={handleRowsPerPageChange}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TemplateLogs